/* @flow */
import React from 'react';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import cx from 'classnames';

import './styles/WalletTabLoader.scss';

export default React.createClass({
  render() {
    return (
      <div className={cx('WalletTabLoader', this.props.className)}>
        <LoadingIndicator />
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/WalletTabLoader.jsx